<template>
    <div class="row">
        <!--Title-->
        <div class="mb-3 text-right col-md-12">
                <h4 class="title center-title pull-left">Evaluaciones</h4>
        </div>
        <!--./Title-->
        <modal :show.sync="showBalance" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="openBalance(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)" @click="openAgroBalance(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
                <div v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)">
                    <p-button @click="openCashFlow(actualAssessmentComputed.old_id,study.id)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && (actualAssessmentComputed.studies.length > 1 || isCustomerPymeConsolidated(actualAssessmentComputed)) && !isFirstAgroConsolidated(actualAssessmentComputed)">
                <p-button @click="openConsolidatedBalance(actualAssessmentComputed.old_id,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openBalance(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy, index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.codebtor_study">
                <p-button v-if="!isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openBalance(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openAgroBalance(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openCashFlow(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showBalanceEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar balance</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="sendBalance(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)" @click="sendBalance(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
                <div v-if="isFirstAgroConsolidated(actualAssessmentComputed) && isFirstAgro(actualAssessmentComputed, index)">
                    <p-button @click="sendCashFlow(actualAssessmentComputed.old_id,actualAssessmentComputed.person)" type="block btn-success">Flujo de caja</p-button>
                </div>
            </div>
            <!-- <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.studies.length > 1"> -->
            <div v-if="actualAssessmentComputed != '' && (actualAssessmentComputed.studies.length > 1 || isCustomerPymeConsolidated(actualAssessmentComputed)) && !isFirstAgroConsolidated(actualAssessmentComputed)">
                <p-button @click="sendConsolidatedBalance(actualAssessmentComputed.old_id,actualAssessmentComputed.person)" type="block btn-success">Balance consolidado</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendBalance(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button @click="sendBalance(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendBalance(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-success">Flujo de caja</p-button>
            </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowBalanceEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showWorksheet" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)"  @click="openWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgro(actualAssessmentComputed,index)"  @click="openAgroWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isSecondAgro(actualAssessmentComputed,index)"  @click="openAgroMicroWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="openWorksheet(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button v-if="!isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openWorksheet(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="openAgroWorksheet(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showWorksheetEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar hoja de trabajo</h4>
            <h6 class="title title-up">Cliente</h6>
            <div v-for="(study,index) in actualAssessmentComputed.studies" :key="study.id">
                <p-button v-if="!isFirstAgroConsolidated(actualAssessmentComputed)" @click="sendWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isFirstAgro(actualAssessmentComputed,index)" @click="sendWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <p-button v-if="isSecondAgro(actualAssessmentComputed,index)" @click="sendAgroMicroWorksheet(actualAssessmentComputed.old_id,study.id)" type="block btn-warning">Estudio {{index + 1}}</p-button>
                <!-- <a href='#' onclick="window.open('https://emi-test.namtrik.dev/export/pdf/worksheet/1/1','Balance','width=250,height=600,screenX=25,screenY=25,resizable=yes,scrollbars=yes '); return false"><p-button type="block btn-warning">Estudio {{study.id}}</p-button></a> -->
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <p-button @click="sendWorksheet(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_study_id)" type="block btn-warning">Estudio</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div v-for="(codebtorStudy,index) in actualAssessmentComputed.codebtors[0].studies" :key="codebtorStudy.id">
                <p-button v-if="!isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendWorksheet(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                <p-button v-if="isAgroCodebtor(actualAssessmentComputed.codebtors[0].studies)" @click="sendWorksheet(actualAssessmentComputed.old_id,codebtorStudy.codebtor_study)" type="block btn-warning">Estudio {{index+1}}</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowWorksheetEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showCharacterAnalysis" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Análisis de caracter</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="openCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.person)" type="block btn-warning">Analisis de caracter</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <div>
                    <p-button @click="openCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                    <p-button @click="openCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.codebtors[0].codebtor_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowCharacterAnalysisMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showCharacterAnalysisEmail" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar análisis de caracter</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.person)" type="block btn-warning">Analisis de caracter</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.spouse_id != null">
                <h6 class="title title-up">Cónyuge</h6>
                <div>
                    <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.spouse_id)" type="block btn-warning">Análisis de caracter</p-button>
                </div>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                <p-button @click="sendCharacterAnalysis(actualAssessmentComputed.old_id,actualAssessmentComputed.codebtors[0].codebtor_id)" type="block btn-warning">Análisis de caracter</p-button>
            </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowCharacterAnalysisEmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM100" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">FM100</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="openFM100(actualAssessmentComputed.fm100IdCustomer)" type="block btn-warning">FM100 Cliente</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0 && actualAssessmentComputed.codebtors[0].fm100IdCodebtor != null">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                <p-button @click="openFM100(actualAssessmentComputed.codebtors[0].fm100IdCodebtor)" type="block btn-warning">FM100</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM100Method()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM100Email" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar FM100</h4>
            <h6 class="title title-up">Cliente</h6>
            <div>
                <p-button @click="sendFM100(actualAssessmentComputed.fm100IdCustomer)" type="block btn-warning">FM100</p-button>
            </div>
            <div v-if="actualAssessmentComputed != '' && actualAssessmentComputed.codebtors.length > 0 && actualAssessmentComputed.codebtors[0].fm100IdCodebtor != null">
                <h6 class="title title-up">Codeudor</h6>
                <div>
                <p-button @click="sendFM100(actualAssessmentComputed.codebtors[0].fm100IdCodebtor)" type="block btn-warning">FM100</p-button>
                </div>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM100EmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM102" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">FM102</h4>
            <h6 class="title title-up">Formulario FM102</h6>
            <div>
                <p-button @click="openFM102(actualAssessmentComputed.fm102Id)" type="block btn-warning">FM102 Evaluación</p-button>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM102Method()" link>Cancelar</p-button>
            </template>
        </modal>
        <modal :show.sync="showFM102Email" headerClasses="justify-content-center">
            <loading :active.sync="isSending"
                :can-cancel="false"
                :is-full-page="fullPage">
            </loading>
            <h4 slot="header" class="title title-up">Enviar FM102</h4>
            <h6 class="title title-up">Evaluación</h6>
            <div>
                <p-button @click="sendFM102(actualAssessmentComputed.fm102Id)" type="block btn-warning">FM102</p-button>
            </div>
            <template slot="footer">
                <p-button type="danger" @click="CancelShowFM102EmailMethod()" link>Cancelar</p-button>
            </template>
        </modal>
        <!--Loading state-->
        <loading :active.sync="this.$apollo.queries.financialAssessments.loading"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading>
        <!--./Loading state-->
        <!--Sending state-->
        <!-- <loading :active.sync="isSending"
        :can-cancel="false"
        :is-full-page="fullPage">
        </loading> -->
        <!--./Sending state-->
        <!--Empty state-->
        <!--<div v-if="tableData && !tableData.length && !this.$apollo.queries.financialAssessments.loading" class="mt-3 col-md-12 card">
            <div class="card-header">
            </div>
            <div class="card-body">
                <img class="no_data_center"  v-bind:src="no_data_image" alt="">
            </div>
        </div>-->
        <!--./Empty state-->
        <!--Filter data-->
        <div class="col-md-12 card">
            <form>
            <div class="card-header">
                <div v-show="!searchSwitch" class="category">Selecciona las fechas</div>
                <div v-show="searchSwitch" class="category">Digite la cédula</div>
                <div class="text-right">
                    <label class="mr-2">Retomar evaluación</label>
                    <p-switch type="warning" v-model="searchSwitch">
                        <i class="fa fa-check" slot="on"></i>
                        <i class="fa fa-times" slot="off"></i>
                    </p-switch>
                </div>
                <div class="text-right">
                    <label class="mr-2">Ver más evaluaciones</label>
                    <p-switch type="warning" v-model="maxAssessmentsSwitch">
                        <i class="fa fa-check" slot="on"></i>
                        <i class="fa fa-times" slot="off"></i>
                    </p-switch>
                </div>
            </div>
            <div v-show="searchSwitch">
                <div class="form-group mb-5 mt-5">
                    <el-input placeholder="Ingresa el número de cédula del titular a retomar" class="input-with-select" v-model="model.search_switch_input">
                        <el-button style="background-color: orange; color: black; border: black;" slot="append" type="warning" icon="el-icon-search" @click="searchSwitchClick"></el-button>
                    </el-input>
                </div>
            </div>
            <div v-show="!searchSwitch">
                <div class="card-body row">
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Fecha inicial</label>
                            <el-date-picker
                                v-model="model.startdate"
                                type="datetime"
                                placeholder="Seleccione fecha inicial"
                                :picker-options="startDatePickerOptions">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Fecha final</label>
                            <el-date-picker
                                v-model="model.enddate"
                                type="datetime"
                                placeholder="Seleccione fecha final">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="form-group">
                            <label>Estado</label>
                            <fg-input
                                        type="text"
                                        name="estado"
                                        autocomplete="off"
                                        :error="getError('estado')">
                                    <el-select class="select-warning"
                                            size="large"
                                            placeholder="Seleccione estado..."
                                            v-model="model.status">
                                    <el-option
                                            class="select-warning"
                                            value="InProcess"
                                            label="En trámite">
                                    </el-option>
                                    <el-option
                                            class="select-warning"
                                            value="Finished"
                                            label="Finalizada">
                                    </el-option>
                                </el-select>
                            </fg-input>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="text-right">
                        <p-button @click.prevent="validate" type="success">Aceptar</p-button>
                        <p-button @click="cancelForm()" type="default" class="pull-left">Cancelar</p-button>
                    </div>
                </div>
            </div>
            </form>
        </div>
        <!--/Filter data-->
        <!--Regionals data-->
        <div v-if="tableData &&  tableData.length && !this.$apollo.queries.financialAssessments.loading" class="col-md-12 card">
        <div class="card-header">
            <div class="category">Lista de evaluaciones</div>
        </div>
        <div class="card-body row">
            <div class="col-sm-4">
                <div>
                    <fg-input class="input-sm"
                            placeholder="Buscar"
                            v-model="searchQuery"
                            addon-right-icon="nc-icon nc-zoom-split">
                    </fg-input>
                </div>
            </div>
            <div class="col-sm-12 mt-2">
            <el-table class="table-striped"
                        :data="queriedData"
                        border
                        style="width: 100%">
                <el-table-column v-for="column in tableColumns"
                                :fixed="column.fixed"
                                :key="column.label"
                                :min-width="column.minWidth"
                                :prop="column.prop"
                                :label="column.label">
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="Balance">
                <template slot-scope="props">
                    <el-tooltip content="Balance" placement="left">
                        <p-button @click="showBalanceMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Enviar" placement="left">
                        <p-button @click="showBalanceEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="H.T">
                <template slot-scope="props">
                    <el-tooltip content="Hoja de trabajo" placement="left">
                        <p-button @click="showWorksheetMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip content="Enviar" placement="left">
                        <p-button @click="showWorksheetEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="E.C">
                <template slot-scope="props">
                    <!-- <el-tooltip content="Evaluación de Caracter" placement="left">
                        <p-button @click="showCharacterAnalysisMethod(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip> -->
                    <el-tooltip content="Enviar" placement="left">
                        <p-button @click="showCharacterAnalysisEmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="FM100">
                <template slot-scope="props">
                    <el-tooltip v-if="props.row.fm100IdCustomer != null" content="Abrir FM100" placement="left">
                        <p-button @click="showFM100Method(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.fm100IdCustomer != null" content="Enviar FM100" placement="left">
                        <p-button @click="showFM100EmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="FM102">
                <template slot-scope="props">
                    <el-tooltip v-if="props.row.fm102Id != null" content="Abrir FM102" placement="left">
                        <p-button @click="showFM102Method(props)" type="danger" size="sm" icon>
                            <i class="fa fa-file-pdf-o"></i>
                        </p-button>
                    </el-tooltip>
                    <el-tooltip v-if="props.row.fm102Id != null" content="Enviar FM102" placement="left">
                        <p-button @click="showFM102EmailMethod(props)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <el-table-column
                :min-width="120"
                class-name="td-actions"
                label="Retoma">
                <template slot-scope="props">
                    <el-tooltip v-if="props.row.financialAssessmentId != null" content="Retomar evaluación" placement="left">
                        <p-button @click="resumeFinancialAssessment(props)" type="danger" size="sm" icon>
                            <i class="fa fa-download"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>
                <!--<el-table-column
                :min-width="120"
                class-name="td-actions"
                label="Enviar">
                <template slot-scope="props">
                    <el-tooltip content="Enviar" placement="left">
                        <p-button @click="showEmailMethod(props.$index)" type="warning" size="sm" icon>
                            <i class="fa fa-share"></i>
                        </p-button>
                    </el-tooltip>
                </template>
                </el-table-column>-->
            </el-table>
            </div>
            <div class="col-sm-6 pagination-info">
            <p class="category">Mostrando {{from + 1}} a {{to}} de {{total}} registros</p>
            </div>
            <div class="col-sm-12 mt-2">
                <el-select
                    class="select-default pull-left"
                    v-model="pagination.perPage"
                    placeholder="Per page">
                    <el-option
                    class="select-default"
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item">
                    </el-option>
                </el-select>
                <p-pagination class="pull-right"
                    v-model="pagination.currentPage"
                    :per-page="pagination.perPage"
                    :total="pagination.total">
                </p-pagination>
            </div>
        </div>
        </div>
        <!--./Regionals data-->
        <div class="text-right">
            <!--<p-button type="warning">Siguiente</p-button>-->
            <p-button @click="toDashboard()" type="warning" class="pull-left mb-3">Atrás</p-button>
        </div>
    </div>
</template>
    <script>
    import swal from 'sweetalert2'
    import PSwitch from 'src/components/UIComponents/Switch.vue'
    import Vue from 'vue'
    import SecureLS from 'secure-ls';
    import {Table, TableColumn, Select, Option, DatePicker, TimeSelect, Button, Input} from 'element-ui'
    import { TimeLine, TimeLineItem, Modal, Badge } from 'src/components/UIComponents'
    import PPagination from 'src/components/UIComponents/Pagination.vue'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { Tooltip } from 'element-ui'
    import gql from 'graphql-tag'
    import { financialAssessments } from 'src/api/graphql/queries/assessments/AllAssessments';
    import { CREATE_ACTIVITY_TYPE } from 'src/api/graphql/mutations/setup/AddEditActivityTypes';
    import { SHARE_GENERAL_BALANCE_EMAIL } from 'src/api/graphql/mutations/share/ShareConsolidatedBalanceEmail';
    import { SHARE_BALANCE_EMAIL } from 'src/api/graphql/mutations/share/ShareBalanceEmail';
    import { SHARE_WORKSHEET_EMAIL } from 'src/api/graphql/mutations/share/ShareWorksheetEmail';
    import { SHARE_AGROMICROWORKSHEET_EMAIL } from 'src/api/graphql/mutations/share/ShareAgroMicroWorksheetEmail';
    import { SHARE_ANALYSIS_EMAIL } from 'src/api/graphql/mutations/share/ShareAnalysisEmail';
    import { SHARE_FM100_EMAIL } from 'src/api/graphql/mutations/share/ShareFm100ByEmail';
    import { SHARE_FM102_EMAIL } from 'src/api/graphql/mutations/share/ShareFm102ByEmail';
    import { REFRESH_TOKEN } from 'src/api/graphql/mutations/auth/RefreshToken';
    import { VERIFY_TOKEN } from 'src/api/graphql/mutations/auth/VerifyToken';
    import { orderBy , sortBy , find } from 'lodash';
    import moment from 'moment'
    import axios from 'axios'
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Option)
    export default{
        /***
        * Esta es la función para hacer todos los llamados de GraphQL al servidor mediante VueApollo
        *
        **/
        apollo:{
        financialAssessments: {
                    query: financialAssessments,
                    variables() {
                        return {
                            status: this.status_fetch,
                            analyst: this.analyst_fetch,
                            office: this.office_fetch,
                            createdAt_Gt: this.startdate_fetch,
                            createdAt_Lt: this.enddate_fetch,
                            debtor_Person_IdentificationNumber: this.debtor_fetch,
                            last: this.last_fetch,
                            maxAssessments: this.maxAssessmentsSwitchQuery
                        }
                    },
                    skip() {
                        return this.skipAssessments
                    },
                    fetchPolicy: 'network-only',
                    // Si tenemos un resultado, pero no encontró el slug.
                    result({ data, loading, networkStatus }) {

                        if(data.financialAssessments.edges.length == 0)
                        {
                            this.showNotificationError('No hay evaluaciones registradas');
                        }
                        else
                        {
                            this.setFinancialAssessments(data.financialAssessments);
                        }

                    },
                    // Si encontró algún error.
                    error(error) {

                    },
                },
        },
        components: {
            PSwitch,
            Modal,
            [Input.name]: Input,
            TimeLine,
            TimeLineItem,
            PPagination,
            Loading,
            Badge,
            [Tooltip.name]: Tooltip,
            [DatePicker.name]: DatePicker,
            [TimeSelect.name]: TimeSelect,
            [Button.name]: Button,
        },
        watch: {
          searchSwitch(newVal){
            if(!newVal){
              this.model.search_switch_input = "";
              this.debtor_fetch = null;
              this.skipAssessments = true;
            }
          }
        },
        computed: {
        actualAssessmentComputed () {
            if (this.actualAssessment != null) {
                return this.actualAssessment;
            }
            else {
                var array = [];
                return array;
            }
        },
        offices_array_computed(){
            return this.offices_array.filter(i => i.regional == this.model.regional)
        },
        pagedData () {
            return this.tableData.slice(this.from, this.to)
        },
        /***
        * Searches through table data and returns a paginated array.
        * Note that this should not be used for table with a lot of data as it might be slow!
        * Do the search and the pagination on the server and display the data retrieved from server instead.
        * @returns {computed.pagedData}
        */
        queriedData () {
            if (!this.searchQuery) {
            this.pagination.total = this.tableData.length
            return this.pagedData
            }
            let result = this.tableData
            .filter((row) => {
                let isIncluded = false
                for (let key of this.propsToSearch) {
                let rowValue = row[key].toString().toLowerCase();
                if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                    isIncluded = true
                }
                }
                return isIncluded
            })
            this.pagination.total = result.length
            return result.slice(this.from, this.to)
        },
        to () {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
            highBound = this.total
            }
            return highBound
        },
        from () {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total () {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        },
        // Opciones para el date picker de fecha inicial
        startDatePickerOptions() {
            // Establecer el límite exactamente hace 2 años desde hoy al inicio del día
            const twoYearsAgo = moment().subtract(2, 'years').startOf('day').toDate();
            const today = moment().endOf('day').toDate();

            return {
                disabledDate(time) {
                    // Deshabilitar fechas anteriores a hace 2 años (sin incluir el día límite) y fechas futuras
                    return time.getTime() < twoYearsAgo.getTime() || time.getTime() > today.getTime();
                }
            };
        },
        },
        data () {
        return {
            searchSwitch: false,
            maxAssessmentsSwitch: false,
            maxAssessmentsSwitchQuery: true,
            showBalance: false,
            showBalanceEmail: false,
            showWorksheet: false,
            showWorksheetEmail: false,
            showCharacterAnalysis: false,
            showCharacterAnalysisEmail: false,
            showFM100Email: false,
            showFM102Email: false,
            showEmail: false,
            showFM100: false,
            showFM102: false,
            actualAssessment: null,
            no_data_image : process.env.VUE_APP_BASE_ROUTE+'img/no_data.png',
            isSending: false,
            fullPage: true,
            debtor_fetch: null,
            last_fetch: null,
            status_fetch: null,
            analyst_fetch: null,
            office_fetch: null,
            startdate_fetch: null,
            enddate_fetch: null,
            tableData: [],
            regionals_array: [],
            offices_array : [],
            users_array: [],
            verifyResponse : false,
            skipAssessments: true,
            financialAssessments_array: [],
            addActivityType : false,//Bandera de creación de tipo de actividad
            editActivityType : false,//Bandera de edición de tipo de actividad
            rowEdit: {},
            formName: 'Cargando...',//Nombre del formulario de creación/edición
            model: {
                startdate: '',
                enddate: '',
                user: '',
                regional: '',
                office: '',
                status: '',
                search_switch_input: ''
            },
            modelValidations: {
            code: {
                required: true,
                numeric: true,
                max: 8
            },
            name: {
                required: true,
                max: 32
            },
            },
            pagination: {
            perPage: 5,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
            },
            searchQuery: '',
            propsToSearch: ['code', 'name'],
            tableColumns: [
            {
                prop: 'code',
                label: 'Cédula',
                minWidth: 120,
                fixed: true
            },
            {
                prop: 'name',
                label: 'Cliente',
                minWidth: 200,
                fixed: false
            },
            {
                prop: 'product',
                label: 'Producto principal',
                minWidth: 200,
                fixed: false
            },
            {
                prop: 'status',
                label: 'Estado',
                minWidth: 250,
                fixed: false
            },
            {
                prop: 'date',
                label: 'Fecha',
                minWidth: 250,
                fixed: false
            },
            {
                prop: 'hour',
                label: 'Hora',
                minWidth: 250,
                fixed: false
            },
            {
                prop: 'assessment',
                label: 'Número solicitud',
                minWidth: 250,
                fixed: false
            },
            // {
            //     prop: 'analyst',
            //     label: 'Analista',
            //     minWidth: 250
            // },
            ],
        }
        },
        methods: {
            getProductName(productType){
                var product = this.$store.getters.getProductTypes.find(product => product.id == productType)
                return product.name
            },
            async openCashFlow(assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/cashflow/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del balance');
                        console.info(error);
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isCustomerConsolidated(financialAssessment){
                var product = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'consumo') {
                    var secondProduct = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[1].productType)
                    if(secondProduct.name.toLowerCase() == 'microcrédito' || secondProduct.name.toLowerCase() == 'microcredito') {
                        return false
                    }
                    else {
                        return true
                    }
                }
                else {
                    return true
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isCustomerPymeConsolidated(financialAssessment){
                var product = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'pequeña empresa') {
                    if(financialAssessment.spouse_study_id != ''){
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
             isFirstAgro(financialAssessment,index){
                if(index == 0) {
                    var product = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario') {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            isFirstAgroConsolidated(financialAssessment){
                var product = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[0].productType)
                if(product.name.toLowerCase() == 'agropecuario') {
                    return true
                }
                else {
                    return false
                }
            },
            isAgroCodebtor(studies){
                var product = this.$store.getters.getProductTypes.find(product => product.id == studies[0].codebtor_product_id)
                if(product.name.toLowerCase() == 'agropecuario') {
                    return true
                }
                else {
                    return false
                }
            },
            isSecondAgro(financialAssessment, index){
                if(index > 0){
                    var product = this.$store.getters.getProductTypes.find(product => product.id == financialAssessment.studies[0].productType)
                    if(product.name.toLowerCase() == 'agropecuario') {
                        return true
                    }
                    else {
                        return false
                    }
                }
                else {
                    return false
                }
            },
            resumeFinancialAssessment(financialAssessment){
                for (let j=0; j < this.$store.state.assesments.length; j++) {
                    if (parseInt(this.$store.state.assesments[j].id_resume) == parseInt(financialAssessment.row.old_id)) {
                        this.showNotificationError('La evaluación ya está siendo retomada en evaluaciones cerradas, no podemos continuar');
                        return
                    }
                }
                var payload = {
                    assessment: financialAssessment.row.jsonObject
                };
                var resumeAssessment = JSON.parse(payload.assessment);
                var id_resume = {
                    id_resume: financialAssessment.row.old_id,
                    created_at: financialAssessment.row.created_at,
                    old_surplus: 0,
                    old_sales: 0
                };
                let now = moment().format();
                var fecha2 = moment(now);
                var fecha1 = moment(financialAssessment.row.created_at);
                var diferencia = fecha2.diff(fecha1, 'days');
                if(diferencia > this.$store.state.daysResume) {
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.credits = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.education = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.feeding = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.health = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.incidentals = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.others = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.public_services = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.rental = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.total = 0;
                    resumeAssessment.customer.studies[0].balance[0].if.expenses.transport = 0;

                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.financial_expenses.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.financial_expenses.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.incidentals.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.incidentals.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.others.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.others.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.public_services.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.public_services.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.rental.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.rental.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.salaries.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.salaries.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.taxes.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.taxes.locked = false;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.total = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.transport.value = 0;
                    resumeAssessment.customer.studies[0].balance[0].er.operative_expenses.transport.locked = false;

                    for(let i=0; i<resumeAssessment.customer.studies[0].operatingExpenses.length;i++){
                        resumeAssessment.customer.studies[0].operatingExpenses[i].value = 0;
                        resumeAssessment.customer.studies[0].operatingExpenses[i].locked = false;
                    }
                    resumeAssessment.customer.studies[0].totalOthersOperatingExpenses = 0;
                }
                resumeAssessment = {...resumeAssessment, ...id_resume};
                this.$store.dispatch('pushResumeAssessment', resumeAssessment).then(()=>{
                    this.$router.push('/admin/finished_evaluations');
                });



            },
            searchSwitchClick() {
            let vm = this;
                if(vm.model.search_switch_input == '' || vm.model.search_switch_input == null) {
                    vm.showNotificationError('Digite la cédula del titular de la evaluación');
                }
                else{
                    if (vm.model.search_switch_input != '') {
                        vm.debtor_fetch = vm.model.search_switch_input;
                        vm.last_fetch = 50;
                    }

                    // Establecer automáticamente la fecha inicial hace 2 años
                    const twoYearsAgo = moment().subtract(2, 'years').startOf('day');
                    vm.startdate_fetch = vm.momentOutput(twoYearsAgo.format());

                    vm.resetPagination();
                    vm.skipAssessments = false;
                    vm.maxAssessmentsSwitchQuery = !vm.maxAssessmentsSwitch;
                    vm.$apollo.queries.financialAssessments.refetch();
                }
            },
            resetPagination() {
                this.pagination = {
                    perPage: 5,
                    currentPage: 1,
                    perPageOptions: [5, 10, 25, 50],
                    total: 0
                }
            },
            verifySession () {
                var vm = this;
                return new Promise(function(resolve, reject) {
                    var accessTokenDecoded = new SecureLS({encodingType: 'aes'});
                    var myToken = accessTokenDecoded.get('accessToken').data;
                    axios.defaults.headers.common["Authorization"] = 'Jwt '+myToken;
                    var refreshToken = accessTokenDecoded.get('refreshToken').data;
                    vm.$apollo.mutate({
                        mutation: VERIFY_TOKEN,
                        variables : {
                            input : {
                                token: myToken,
                            }
                        }
                    }).then((data) => {
                        resolve(true);
                    }).catch((error) => {
                        if(error.graphQLErrors.length > 0)
                        {
                            if (error.graphQLErrors[0].message == "Signature has expired") {
                                vm.$apollo.mutate({
                                    mutation: REFRESH_TOKEN,
                                    variables : {
                                        input : {
                                        refreshToken: refreshToken,
                                        }
                                    }
                                }).then((data) => {
                                    vm.$store.dispatch('updateToken',data.data.refreshToken).then(()=>{
                                        resolve(true);
                                    });
                                }).catch((error) => {
                                    resolve(false);
                                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                                });
                            }
                        }
                        else {
                            resolve(false);
                            vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                        }
                    });
                });
            },
            resetOffice () {
                this.model.office = '';
            },
            async openFM100 (fmId) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'fm100/'+fmId,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showFM100 = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del formulario');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openFM102 (fmId) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'fm102/'+fmId,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        var myWindow = window.open(url)
                        if (myWindow == null) {
                            vm.showFM100 = false;
                            vm.showNotificationError('Debes autorizar las ventanas emergentes para este sitio');
                        }
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del formulario');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error, inténtalo de nuevo');
                }
            },
            async openConsolidatedBalance (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'consolidatedbalance/'+assessment+'/'+person,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de un balance consolidado');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
             async sendConsolidatedBalance (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareGeneralBalanceByEmailMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_GENERAL_BALANCE_EMAIL,
                        variables : {
                            input: shareGeneralBalanceByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('El balance ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;

                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openCharacterAnalysis (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'characteranalysis/'+assessment+'/'+person,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la evaluación de caracter');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async sendCharacterAnalysis (assessment, person) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareAnalysisByEmailMutationInput = {
                        assessment : assessment,
                        person: person,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_ANALYSIS_EMAIL,
                        variables : {
                            input: shareAnalysisByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('El análisis de caracter ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;

                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'balance/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del balance');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openAgroBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/balance/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos del balance');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async sendBalance (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareBalanceByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.errors.clear();
                    vm.$apollo.mutate({
                        mutation: SHARE_BALANCE_EMAIL,
                        variables : {
                            input: shareBalanceByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('El balance ha sido enviado al correo de la oficina correctamente');
                    }).catch((error) => {
                        vm.isSynchronizing = false;

                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openAgroWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async openAgroMicroWorksheet(assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    axios({
                        method: 'get',
                        url: process.env.VUE_APP_PDF_URL+'agro/comercial/worksheet/'+assessment+'/'+study,
                        responseType: 'arraybuffer',
                    }).then(function(response) {
                        vm.isSending = false;
                        let blob = new Blob([response.data], { type: 'application/pdf' })
                        let url = window.URL.createObjectURL(blob)
                        window.open(url)
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error consultando en el sistema, es posible que no existan datos de la hoja de trabajo');

                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async sendWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareWorksheetByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_WORKSHEET_EMAIL,
                        variables : {
                            input: shareWorksheetByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('La hoja de trabajo ha sido enviada correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            async sendAgroMicroWorksheet (assessment, study) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareWorksheetByEmailMutationInput = {
                        creditStudy : study,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_AGROMICROWORKSHEET_EMAIL,
                        variables : {
                            input: shareWorksheetByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('La hoja de trabajo ha sido enviada correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSending = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            async sendFM100 (fm100Id) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareFM100ByEmailMutationInput = {
                        fm100 : fm100Id,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_FM100_EMAIL,
                        variables : {
                            input: shareFM100ByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('El FM100 ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSynchronizing = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            /**
             * This function adds one to its input.
             * @param {number} input any number
             * @returns {number} that number, plus one.
             */
            async sendFM102 (fm102Id) {
                var vm = this;
                vm.isSending = true;
                let response = await vm.verifySession();
                if (response) {
                    var shareFM100ByEmailMutationInput = {
                        fm102 : fm102Id,
                    };
                    vm.$apollo.mutate({
                        mutation: SHARE_FM102_EMAIL,
                        variables : {
                            input: shareFM100ByEmailMutationInput
                        }
                    }).then((data) => {
                        vm.isSending = false;
                        vm.showNotificationSuccess('El FM102 ha sido enviado correctamente');
                    }).catch((error) => {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    });
                }
                else {
                    vm.isSynchronizing = false;
                    vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                }
            },
            showBalanceMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showBalance = true;
            },
            showBalanceEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showBalanceEmail = true;
            },
            showCharacterAnalysisMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showCharacterAnalysis = true;
            },
            showCharacterAnalysisEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showCharacterAnalysisEmail = true;
            },
            showFM100EmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM100Email = true;
            },
            showFM100Method (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM100 = true;
            },
            showFM102EmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM102Email = true;
            },
            showFM102Method (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showFM102 = true;
            },
            CancelShowCharacterAnalysisMethod () {
                this.actualAssessment = null;
                this.showCharacterAnalysis = false;
            },
            CancelShowCharacterAnalysisEmailMethod () {
                this.actualAssessment = null;
                this.showCharacterAnalysisEmail = false;
            },
            CancelShowFM100EmailMethod () {
                this.actualAssessment = null;
                this.showFM100Email = false;
            },
            CancelShowFM100Method () {
                this.actualAssessment = null;
                this.showFM100 = false;
            },
            CancelShowFM102EmailMethod () {
                this.actualAssessment = null;
                this.showFM102Email = false;
            },
            CancelShowFM102Method () {
                this.actualAssessment = null;
                this.showFM102 = false;
            },
            CancelShowBalanceMethod () {
                this.actualAssessment = null;
                this.showBalance = false;
            },
            CancelShowBalanceEmailMethod () {
                this.actualAssessment = null;
                this.showBalanceEmail = false;
            },
            CancelShowWorksheetMethod () {
                this.actualAssessment = null;
                this.showWorksheet = false;
            },
            CancelShowWorksheetEmailMethod () {
                this.actualAssessment = null;
                this.showWorksheetEmail = false;
            },
            showWorksheetMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showWorksheet = true;
            },
            showWorksheetEmailMethod (index) {
                this.actualAssessment = this.financialAssessments_array.find(i => i.assessment == index.row.assessment);
                this.showWorksheetEmail = true;
            },
            showCharacterMethod (index) {
                this.showCharacter = true;
            },
            showEmailMethod (index) {
                this.showEmail = true;
            },
            /***
             * Función para setear en la tabla los datos que llegan desde las evalaciones
             */
            setFinancialAssessments(financialAssessments){
                var vm = this;
                vm.financialAssessments_array = [];
                for(let i=0;i<financialAssessments.edges.length;i++)
                {
                    vm.pushFinancialAssessments(financialAssessments.edges[i].node);
                }
                vm.orderFinancialAssessments();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la Regional
             */
            setRegionals(regionals){
                var vm = this;
                for(let i=0;i<regionals.edges.length;i++)
                {
                    vm.pushRegionalsData(regionals.edges[i].node);
                }
                vm.orderRegionalsData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde la oficina
             */
            setOffices(offices){
                var vm = this;
                for(let i=0;i<offices.edges.length;i++)
                {
                    vm.pushOfficesData(offices.edges[i].node);
                }
                vm.orderOfficesData();
            },
            /***
             * Función para setear en la tabla los datos que llegan desde el usuario
             */
            setUsers(users){
                var vm = this;
                for(let i=0;i<users.edges.length;i++)
                {
                    vm.pushUsersData(users.edges[i].node);
                }
                vm.orderUsersData();
            },
            /***
            * Función que valida si se está enviando o cargando datos
            */
            handleLoading(){
            if(isLoading == true || isSending == true){
                return true
            }
            else{
                return false
            }
            },

            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro exitoso
            */
            onSuccess(message){
                swal({
                    title: `¡Correcto!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-success btn-fill',
                    type: 'success'
                });
            },
            /***
            * Función que muestra un mensaje en notificación tipo SweetAlert cuando sucede un registro erróneo
            */
            onError(message){
                swal({
                    title: `¡Alerta!`,
                    text: message,
                    buttonsStyling: false,
                    confirmButtonClass: 'btn btn-danger btn-fill',
                    type: 'error'
                });
            },
            /***
            * Función que cancela la creación/edición de usuarios y resetea los campos
            */
            cancelForm(){
                this.skipAssessments = true;
                this.tableData = [];
                this.model.startdate = '';
                this.model.enddate = '';
                this.model.user = '';
                this.model.status = '';
                this.model.regional = '';
                this.model.office = '';
                this.status_fetch= null;
                this.analyst_fetch= null;
                this.office_fetch= null;
                this.startdate_fetch= null;
                this.enddate_fetch= null;
                this.debtor_fetch= null;
                this.errors.clear();
                window.scrollTo(0,0);
            },
            /***
            * Función que oculta el formulario de creación/edición una vez realizado un envío de datos al servidor
            */
            reloadData(){
                var vm = this;
                vm.resetForm();
                vm.setVisibleForm(false,false)//Asignamos las variables de visualización del formulario
            },
            /***
            * Función para agregar un objeto al arreglo de datos
            */
            pushUsersData(node){
                var vm = this;
                vm.users_array.push({
                    id: node.id,
                    name: node.name,
                    surname: node.surname,
                    username: node.username,
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de evaluaciones
            */
            pushFinancialAssessments(node){
                moment.locale('es');
                var vm = this;
                var status;
                var studies = [];
                var codebtors = [];
                var fm100IdCustomer = null;
                var fm100IdCodebtor = null;
                var fm102Id = null;
                var spouse_study_id = null;
                var spouse_id = null;
                var productName = null;
                if (node.status == 'FINISHED') {
                    status = 'Finalizado';
                }
                else {
                    status = 'En trámite';
                }
                if (node.debtor.creditstudySet.edges.length > 0) {
                    for (let i=0;i<node.debtor.creditstudySet.edges.length;i++) {
                        studies.push({
                            id: vm.idDecode(node.debtor.creditstudySet.edges[i].node.id),
                            productType: node.debtor.creditstudySet.edges[i].node.productType.id
                        })
                    }
                }
                productName = vm.getProductName(studies[0].productType);
                if (node.debtor.spouse != null) {
                    spouse_study_id = vm.idDecode(node.debtor.spouse.creditstudy.id);
                    spouse_id = vm.idDecode(node.debtor.spouse.person.id);
                }
                if (node.debtor.fm100 != null) {
                    fm100IdCustomer = vm.idDecode(node.debtor.fm100.id);
                }
                if (node.fm102 != null) {
                    fm102Id = vm.idDecode(node.fm102.id);
                }
                // if (node.codebtorSet.edges.length > 0) {
                //     for (let i=0;i<node.codebtorSet.edges.length.length;i++) {
                //         var codebtorStudies = [];
                //         if (node.codebtorSet.edges[i].node.creditstudySet.edges.length > 0) {
                //             for (let j=0;j<node.codebtorSet.edges[i].node.creditstudySet.edges.length;j++) {
                //                 codebtorStudies.push({
                //                     id: vm.idDecode(node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.id)
                //                 })
                //             }
                //         }
                //         codebtors.push({
                //             name: node.codebtorSet.edges[i].node.person.fullName,
                //             studies: codebtorStudies
                //         })
                //     }
                // }

                if(node.codebtorSet != null && node.codebtorSet.edges.length != 0) {
                    for (let i=0;i<node.codebtorSet.edges.length;i++) {
                        var codebtorStudies = [];
                        if (node.codebtorSet.edges[i].node.creditstudySet.edges.length > 0) {
                            for (let j=0;j<node.codebtorSet.edges[i].node.creditstudySet.edges.length;j++) {
                                codebtorStudies.push({
                                    codebtor_study: vm.idDecode(node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.id),
                                    codebtor_product_id : node.codebtorSet.edges[i].node.creditstudySet.edges[j].node.productType.id
                                })
                            }
                        }
                        if (node.codebtorSet.edges[i].node.fm100 != null) {
                            codebtors.push({
                                name: node.codebtorSet.edges[i].node.person.fullName,
                                codebtor_id: vm.idDecode(node.codebtorSet.edges[i].node.person.id),
                                fm100IdCodebtor: vm.idDecode(node.codebtorSet.edges[i].node.fm100.id),
                                studies: codebtorStudies
                            })
                        }
                        else {
                            codebtors.push({
                                name: node.codebtorSet.edges[i].node.person.fullName,
                                codebtor_id: vm.idDecode(node.codebtorSet.edges[i].node.person.id),
                                fm100IdCodebtor: null,
                                studies: codebtorStudies
                            })
                        }

                    }
                }
                vm.financialAssessments_array.push({
                    assessment: (node.financialAssessmentId != null) ? node.financialAssessmentId : vm.idDecode(node.id),
                    financialAssessmentId: node.financialAssessmentId,
                    old_id : vm.idDecode(node.id),
                    created_at: node.createdAt,
                    jsonObject: node.jsonObject,
                    status: status,
                    date: moment(node.createdAt).format('LL'),
                    hour: moment(node.createdAt).format('h:mm a'),
                    analyst: null,
                    person: vm.idDecode(node.debtor.person.id),
                    name: node.debtor.person.fullName,
                    code: node.debtor.person.identificationNumber,
                    fm100IdCustomer: fm100IdCustomer,
                    fm102Id: fm102Id,
                    studies: studies,
                    codebtors: codebtors,
                    spouse_study_id: spouse_study_id,
                    spouse_id: spouse_id,
                    product: productName
                });
                // console.info(vm.financialAssessments_array);
            },
            /***
            * Función para agregar un objeto al arreglo de datos de regionales
            */
            pushRegionalsData(node){
                var vm = this;
                vm.regionals_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name
                });
            },
            /***
            * Función para agregar un objeto al arreglo de datos de oficinas
            */
            pushOfficesData(node){
                var vm = this;
                vm.offices_array.push({
                    id: node.id,
                    code: node.code,
                    name: node.name,
                    regional: node.regional.id
                });
            },
            /***
            * Función para ordenar el arreglo de datos
            */
            orderData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.tableData, o => o.name);
                // vm.tableData = myOrderedArray;
                vm.tableData = vm.assessments;
            },
            /***
            * Función para ordenar el arreglo de datos de usuarios
            */
            orderUsersData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.users_array, o => o.name);
                vm.users_array = myOrderedArray;
            },
            orderFinancialAssessments() {
                var vm = this;
                // Ordenar por la fecha de `created_at` en orden descendente
                vm.tableData = _.orderBy(vm.financialAssessments_array, obj => new Date(obj.created_at), ['desc']);
            },
            orderRegionalsData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.regionals_array, o => o.name);
                vm.regionals_array = myOrderedArray;
            },
            /***
            * Función para ordenar el arreglo de datos de regionales
            */
            orderOfficesData(){
                var vm = this;
                const myOrderedArray = _.sortBy(vm.offices_array, o => o.name);
                vm.offices_array = myOrderedArray;
            },
            /***
            * Función para decodificar el ID en base 64
            */
            idDecode(id){
                let id_decoded = atob(id);
                return id_decoded.split(":")[1];
            },
            /***
            * Función para mostrar un mensaje de éxito
            */
            showNotificationSuccess (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-check-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'success'
                })
            },
            /***
            * Función para mostrar un mensaje de error
            */
            showNotificationError (message) {
                this.$notify(
                {
                    message: message,
                    icon: 'nc-icon nc-glasses-2',
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                })
            },
            /***
            * Función que permite visualizar los errores en cada campo del input
            */
            getError (fieldName) {
                return this.errors.first(fieldName)
            },
            /**
             * Función para dar formato de hora a los datos de salida
             */
            momentOutput(date) {
                moment.locale('es');
                return moment(date).format();
            },
            toDashboard() {
                this.$router.push('/');
            },
            /***
            * Función para validar el formulario de edición y creación que se envía
            */
            async validate () {
                var vm = this;
                let response = await vm.verifySession();
                if (response) {
                        this.$validator.validateAll().then(isValid => {
                        if(isValid){
                            vm.tableData = []
                            if((vm.model.startdate != '' && vm.model.enddate == '') || (vm.model.startdate == '' && vm.model.enddate != '')){
                                vm.onError('Las dos fechas son obligatorias');
                                return
                            }
                            if(vm.model.startdate > vm.model.enddate){
                                vm.onError('La fecha de inicio no puede ser mayor a la fecha de fin');
                                return
                            }
                            // Validación adicional: fecha inicial no puede ser anterior a hace 2 años
                            if(vm.model.startdate) {
                                const twoYearsAgo = moment().subtract(2, 'years').startOf('day');
                                const selectedStartDate = moment(vm.model.startdate).startOf('day');

                                if(selectedStartDate.isBefore(twoYearsAgo)) {
                                    vm.onError('La fecha inicial no puede ser anterior a ' + twoYearsAgo.format('DD/MM/YYYY'));
                                    return
                                }
                            }
                            if (vm.model.regional != '' && vm.model.office == '') {
                                vm.onError('Debe seleccionar una oficina');
                                return
                            }
                            if (vm.model.regional != '' && vm.model.office != '') {
                                vm.office_fetch = vm.idDecode(vm.model.office);
                            }
                            if (vm.model.startdate != '') {
                                vm.startdate_fetch = vm.momentOutput(vm.model.startdate);
                                vm.enddate_fetch = vm.momentOutput(vm.model.enddate);
                            }
                            if (vm.model.user != '') {
                                vm.analyst_fetch = vm.idDecode(vm.model.user);
                            }
                            if (vm.model.status != '') {
                                vm.status_fetch = vm.model.status;
                            }
                            vm.resetPagination();
                            vm.skipAssessments = false;
                            vm.maxAssessmentsSwitchQuery = !vm.maxAssessmentsSwitch;
                            vm.$apollo.queries.financialAssessments.refetch();
                        }
                        })
                    }
                    else {
                        vm.isSending = false;
                        vm.showNotificationError('Ha ocurrido un error conectándose al sistema, revise su conexión e inténtelo de nuevo');
                    }
            }
        },
        mounted() {
            // this.test();
            // alert(this.$window.csrf_token);
            this.model.startdate = moment().startOf('isoWeek').format();
            this.model.enddate = moment().endOf('isoWeek').format();
        }
    }
    </script>
    <style lang="scss">
    .el-table .td-actions{
    button.btn {
        margin-right: 5px;
    }
    }
    // Función para centrar la imagen del Empty State
    .no_data_center {
        display: block;
        margin-left: auto;
        margin-right: auto;
        max-width: 500px;
    }
    // Estilos para poder centrar el título de la actividad
    .center-title {
        margin-top: 0;
        margin-bottom: 0;
    }

</style>
